import React from 'react';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { Relative } from '../layouts';
import { NotificationIndicator } from './notificationIndicator';

export const withNotification = (Component) => {
  const NotificationComponent = ({
    className,
    indicatorPosition,
    notify,
    children,
    ...rest
  }) => {
    const componentClasses = serializeClasses([className]);
    return (
      <Relative>
        <Component {...rest} className={componentClasses}>
          {children}
        </Component>
        {notify && <NotificationIndicator {...indicatorPosition} />}
      </Relative>
    );
  };
  NotificationComponent.propTypes = {
    className: PropTypes.string,
    notify: PropTypes.bool,
    children: PropTypes.node,
    indicatorPosition: PropTypes.object,
  };
  NotificationComponent.defaultProps = {
    className: null,
    notify: false,
    children: undefined,
    indicatorPosition: { right: '-10px', top: '-10px' },
  };

  return NotificationComponent;
};
